import { defineMessages } from 'react-intl'

export default defineMessages({
  alert: {
    id: 'component.functional.contact-form.alert',
    defaultMessage: 'Du måste ange ditt företag!',
  },

  // Headings
  companyInfoHeading: {
    id: 'component.functional.contact-form.headings.company-information',
    defaultMessage: 'Om företaget',
  },
  contactInfoHeading: {
    id: 'component.functional.contact-form.headings.contact-information',
    defaultMessage: 'Kontaktinformation',
  },

  // Label / placeholder messages
  labelName: {
    id: 'component.functional.contact-form.labels.name',
    defaultMessage: 'Namn',
  },
  labelEmail: {
    id: 'component.functional.contact-form.labels.email',
    defaultMessage: 'Email',
  },
  labelPhone: {
    id: 'component.functional.contact-form.labels.phone',
    defaultMessage: 'Mobilnummer',
  },
  labelCompanyName: {
    id: 'component.functional.contact-form.labels.company-name',
    defaultMessage: 'Företagsnamn',
  },
  labelCompanyStatus: {
    id: 'component.functional.contact-form.labels.company-status',
    defaultMessage: 'Bolagsstatus',
  },
  labelCompanyForm: {
    id: 'component.functional.contact-form.labels.company-form',
    defaultMessage: 'Bolagsform',
  },
  labelCompanyBranch: {
    id: 'component.functional.contact-form.labels.company-branch',
    defaultMessage: 'Bransch',
  },
  labelCompanyEmployees: {
    id: 'component.functional.contact-form.labels.company-employees',
    defaultMessage: 'Antal anställda',
  },
  labelDescription: {
    id: 'component.functional.contact-form.labels.description',
    defaultMessage: 'Frågor eller annan information',
  },
  labelAgreements: {
    id: 'component.functional.contact-form.labels.agreements',
    defaultMessage: 'Jag godkänner Dooers hantering av mina <link1>personuppgifter</link1>',
  },
  labelFindCompany: {
    id: 'component.functional.contact-form.labels.find-company',
    defaultMessage: 'Sök ditt företag *',
  },

  // Other
  cta: {
    id: 'component.functional.contact-form.cta',
    defaultMessage: 'Kontakta mig',
  },

  // Error messages
  errorName: {
    id: 'component.functional.contact-form.errors.name',
    defaultMessage: 'Du måste ange ditt namn',
  },
  errorEmail: {
    id: 'component.functional.contact-form.errors.email',
    defaultMessage: 'Du måste ange en giltig epost',
  },
  errorPhone: {
    id: 'component.functional.contact-form.errors.phone',
    defaultMessage: 'Du måste ange ett giltigt telefonnummer',
  },
  errorAgreements: {
    id: 'component.functional.contact-form.errors.agreements',
    defaultMessage: 'Du måste läsa och acceptera villkoren',
  },

  optionCompanyBankDefault: {
    id: 'component.functional.contact-form.options.company-bank.default',
    defaultMessage: 'Bank *',
  },
  optionCompanyBankOther: {
    id: 'component.functional.contact-form.options.company-bank.other',
    defaultMessage: 'Annan',
  },
  // Company status options
  optionCompanyStatusDefault: {
    id: 'component.functional.contact-form.options.company-status.default',
    defaultMessage: 'Bolagsstatus',
  },
  optionCompanyStatusNotStarted: {
    id: 'component.functional.contact-form.options.company-status.not-started',
    defaultMessage: 'Ej ännu startad',
  },
  optionCompanyStatusNew: {
    id: 'component.functional.contact-form.options.company-status.new',
    defaultMessage: 'Nystartad (inte gjort ett årsbokslut)',
  },
  optionCompanyStatusActive: {
    id: 'component.functional.contact-form.options.company-status.active',
    defaultMessage: 'Äldre än 1 år',
  },

  // Company form options
  optionCompanyFormDefault: {
    id: 'component.functional.contact-form.options.company-form.default',
    defaultMessage: 'Bolagsform',
  },
  optionCompanyFormLimitedCompany: {
    id: 'component.functional.contact-form.options.company-form.limited-company',
    defaultMessage: 'Aktiebolag',
  },
  optionCompanyFormSoleProprietorship: {
    id: 'component.functional.contact-form.options.company-form.sole-proprietorship',
    defaultMessage: 'Enskild firma',
  },
  optionCompanyFormTradingCompany: {
    id: 'component.functional.contact-form.options.company-form.trading-company',
    defaultMessage: 'Handelsbolag',
  },
  optionCompanyFormOther: {
    id: 'component.functional.contact-form.options.company-form.other',
    defaultMessage: 'Övrigt',
  },

  optionCompanyBranchDefault: {
    defaultMessage: 'Bransch *',
    id: 'component.functional.contact-form.options.company-branch.default',
  },

  // Company revenue options
  optionCompanyRevenue: {
    defaultMessage: 'Omsättning',
    id: 'component.functional.contact-form.options.company-revenue.default',
  },
  optionCompanyRevenue0: {
    defaultMessage: '0-1 MSEK/år',
    id: 'component.functional.contact-form.options.company-revenue.0-1',
  },
  optionCompanyRevenue1: {
    defaultMessage: '1-3 MSEK/år',
    id: 'component.functional.contact-form.options.company-revenue.1-3',
  },
  optionCompanyRevenue3: {
    defaultMessage: '3-5 MSEK/år',
    id: 'component.functional.contact-form.options.company-revenue.3-5',
  },
  optionCompanyRevenue5: {
    defaultMessage: '5+ MSEK/år',
    id: 'component.functional.contact-form.options.company-revenue.5',
  },

  // Submitted
  submittedHeading: {
    id: 'component.functional.contact-form.submitted.heading',
    defaultMessage: 'Perfekt!',
  },
  submittedLede: {
    id: 'component.functional.contact-form.submitted.lede',
    defaultMessage:
      'Nu kommer vi inom kort kontakta dig för att berätta mer om Dooer och hur vi kan hjälpa dig och ditt företag.',
  },
})
